module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "编辑"
    },
    on: {
      "on-visible-change": _vm.onVisibleChange
    },
    model: {
      value: (_vm.showIs),
      callback: function($$v) {
        _vm.showIs = $$v
      },
      expression: "showIs"
    }
  }, [_c('Form', {
    ref: "form",
    staticClass: "form",
    attrs: {
      "model": _vm.formData,
      "rules": _vm.formRule,
      "label-width": 80
    }
  }, [_c('Row', [_c('i-col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "物流名称",
      "prop": "logicName"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.formData.logicName),
      callback: function($$v) {
        _vm.$set(_vm.formData, "logicName", $$v)
      },
      expression: "formData.logicName"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "物流单号",
      "prop": "logicNumber"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.formData.logicNumber),
      callback: function($$v) {
        _vm.$set(_vm.formData, "logicNumber", $$v)
      },
      expression: "formData.logicNumber"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.showIs = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingEdit
    },
    on: {
      "click": _vm.edit
    }
  }, [_vm._v("保存")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ad8a811","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/market/modal/LogicModal.vue
// module id = 1746
// module chunks = 8